import {CommonModule} from '@angular/common' ;
import {HttpClientModule} from '@angular/common/http' ;
import {NgModule, ModuleWithProviders} from '@angular/core' ;
import {PakkkExceptiontestsService} from './rest/pakkk-exceptiontests.service' ;
 
@NgModule({
  imports: [ 
            CommonModule,
        	HttpClientModule 
           ]
})
 
export class PakkkExceptiontestsModule
{
	static forRoot(): ModuleWithProviders {
        return {
            ngModule: PakkkExceptiontestsModule,
            providers: [
                PakkkExceptiontestsService
            ]
        } ;
    }
}